/* eslint-disable no-restricted-imports */
import { DpButton } from '@/components/blocks/DpLibrary/DpButton';
import { ACCOUNT_QUERY_TABS } from '@/components/content/Account';
import { useDpvaleFlow } from '@/data/Content/Dpvale';
import { useLocalization } from '@/data/Localization';
import { Box, Typography } from '@mui/material';
import { formatPrice } from 'integration/utils/formatPrice';

export const CurrentDpvale = () => {
	const { currentSelectedDpvale } = useDpvaleFlow();
	const routes = useLocalization('Routes');

	if (!currentSelectedDpvale) {
		return null;
	}

	return (
		<Box sx={{ backgroundColor: '#222222', padding: '10px' }}>
			<Typography
				sx={{
					color: '#fff',
					fontSize: 'var(--font-size-default)',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					gap: '10px',
				}}
			>
				{`Comprar a: 
                    ${currentSelectedDpvale.distributor.name} (saldo ${formatPrice(
					currentSelectedDpvale.amount,
					'mxn'
				)})  `}
				<DpButton
					variant="text"
					sx={{ color: '#fff', textDecoration: 'underline' }}
					href={{
						pathname: `/${routes.Account.route.t()}`,
						query: { tab: ACCOUNT_QUERY_TABS.DPVALE },
					}}
				>
					{'Cambiar'}
				</DpButton>
			</Typography>
		</Box>
	);
};
